import React, { Component } from "react";
import { connect } from "react-redux";
import { css } from "aphrodite";
import styles from "./users-and-permissions-styles";
import UserListing from "./users-listing/users-listing";
import UserForm from "./users-form/users-form";

import { ContentCard, FilledGreenButton } from "../common";

class UsersAndPermissions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showForm: false
    };
  }

  _onInvitePress = () => {
    this.setState({ showForm: true });
  };

  _onFormCancelPress = () => {
    this.setState({ showForm: false });
  };

  render() {
    const { showForm } = this.state;
    return (
      <div className={css(styles.root)}>
        <ContentCard title={"Add User"}>
          <FilledGreenButton
            title={"Invite New User"}
            onClick={this._onInvitePress}
          />
        </ContentCard>

        {showForm && <UserForm onCancelPress={this._onFormCancelPress} />}

        <UserListing />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  usersAndPermissions: state.usersAndPermissions
});

const mapDispatchToProps = {
  // requestUsersList: requestUsersList
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersAndPermissions);



// WEBPACK FOOTER //
// ./src/components/users-and-permissions/users-and-permissions.js